import React, { useState } from 'react';
import { PageHeader } from '../components/website/pageHeader';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import axios from 'axios';
import { API_ENDPOINTS } from '../config/apiConfig';

const initialState = {
    name: "",
    email: "",
    message: "",
};

function Contact() {
    const [contactRef, isContactVisible] = useScrollAnimation({ threshold: 0.15 });
    const [messageSent, setMessageSent] = useState(false);
    const [formRef, isFormVisible] = useScrollAnimation({ threshold: 0.2 });
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const [{ name, email, message }, setState] = useState(initialState);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prevState) => ({ ...prevState, [name]: value }));
    };

    const clearState = () => setState({ ...initialState });

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(name, email, message);

        axios.post(API_ENDPOINTS.contact, {
            "name": name,
            "email": email,
            "message": message,
        })
            .then((response) => {
                console.log(response);
                setSuccessMessage("Your message has been sent! We will get back to you as soon as possible.");
                clearState();
                setMessageSent(true);
            })
            .catch((error) => {
                console.log(error);
                setErrorMessage("Something went wrong. Please try again.");
            });
    };

    return (
        <div className="bg-[#f3f3f3] pb-4 font-nunito min-h-screen">
            <PageHeader 
                text="Contact Us"
                subtext="Have a question? Want to book a demo? Leave us a message and we will respond to you as soon as possible."
                image={"./img/homepage/fleet.png"}
            />
            {/* Contact Form */}
            {messageSent ? (
                <div className="max-w-7xl mx-auto px-5 py-10 bg-white rounded-[20px] p-12 m-12 lg:p-16 shadow-sm transition-all duration-1000 ease-out transform">
                    <p className="text-center text-gray-600 mb-10 font-nunito">
                        Your message has been sent! We will get back to you as soon as possible.
                    </p>
                </div>
            ) : (
                <div
                    ref={contactRef}
                    className={`max-w-7xl mx-auto px-5 py-10 bg-white rounded-[20px] p-12 m-12 lg:p-16 shadow-sm transition-all duration-1000 ease-out transform ${isContactVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                        }`}
                >
                    <form onSubmit={handleSubmit} className="w-full max-w-4xl mx-auto">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="mb-4">
                                <label className="block text-gray-700 font-bold mb-2" htmlFor="name">Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={name}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </div>
                            <div className="mb-4">
                                <label className="block text-gray-700 font-bold mb-2" htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={email}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="block text-gray-700 font-bold mb-2" htmlFor="message">Message</label>
                            <textarea
                                id="message"
                                name="message"
                                value={message}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-fit bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                        >
                            Submit
                        </button>
                    </form>
                </div>
            )}
        </div>
    );
}

export default Contact;